import React, {Fragment, useState} from 'react';
import {resetFocus} from "../common/commonUtilities";
import Link from "../common/components/Link";
import ExtraInfo from "./ExtraInfo";
import Button from 'react-bootstrap/Button'
import { Icon } from 'semantic-ui-react'

// displays a hyperlink for any extra info, when clicked, causes all the extra info to display
export default function ExtraInfoLink({title, content}) {
  const [showExtraInfo, setShowExtraInfo] = useState(false);

  const handleExtraInfoClose = () => {
    resetFocus();
    setShowExtraInfo(false);
  }

  const handleExtraInfoOpen = () => {
    setShowExtraInfo(true);
  }

  return (  <Fragment>
      <span className="extra-info-button-row">
        <Button
          title="Click to show information"
          onClick={handleExtraInfoOpen}
        >
        <span>
          <span>{title} </span>
          <Icon name="external" />
        </span>
        </Button>
      </span>
      {showExtraInfo && (
        <ExtraInfo
          title={title}
          content={content}
          show={showExtraInfo}
          onHide={handleExtraInfoClose}
        />
      )}
    </Fragment>
  );
}
